import * as Constants from '../constants/transaction';

const initialState = {
  petTransactions: [],
  activeTransaction: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_PET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        petTransactions: action.payload,
      };
    case Constants.GET_TRANSACTION_SUCCESS:
    case Constants.UPDATE_TRANSACTION_SUCCESS:
    case Constants.APPLY_CODE_SUCCESS:
    case Constants.RESCAN_FOR_CODES_SUCCESS:
      return {
        ...state,
        activeTransaction: action.payload,
      };
    case Constants.CLEAR_TRANSACTION:
      return {
        ...state,
        activeTransaction: null,
      };
    default:
      return state;
  }
};
